import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Job } from '../../class/job.class';
import { WsUpdateTaskMessage } from '../../models/ws-update-task-message.model';
import { SortType } from '../../types/sort.type';

export const JobsActions = createActionGroup({
  source: 'Jobs',
  events: {
    'Add Job': props<{ job: Job }>(),
    'Remove Job': props<{ jobId: number }>(),
    'Load Jobs': emptyProps(),
    'Add Jobs': props<{ jobs: Job[] }>(),
    'Update Job From Ws Message': props<{ wsUpdateTaskMessage: WsUpdateTaskMessage }>(),
    'Sort Jobs':props<{sortType:SortType}>()
  },
});